export default "__VITE_ASSET__CPRfqJec__"